import { AccountStatus } from "../../services/cloudchipr.api";
import { getAddMissingOrgAccountAccessRoleFeatureToggleToStorage } from "@/components/pages/accounts-group/components/accounts/utils/helpers";

export const nonWorkingAccountStatuses = new Set<AccountStatus>([
  "deactivated",
  "connected_for_billing",
  "inactive",
  "deleting",
]);

export const nonDetachableAccountStatuses = new Set<AccountStatus>([
  "connected_for_billing",
  "deleting",
]);

export const activeAccountStatuses = new Set<AccountStatus>([
  "connected",
  "initial_pulling",
  "deleting",
  "missing_sub_account_role",
]);

export const loadingAccountStatuses = new Set<AccountStatus>([
  "initial_pulling",
]);

export const getActiveAccountStatuses = () => {
  const enableAddMissingOrgAccountAccessRole =
    getAddMissingOrgAccountAccessRoleFeatureToggleToStorage();
  const set = new Set(["connected", "initial_pulling", "deleting"]);
  if (enableAddMissingOrgAccountAccessRole) {
    set.add("missing_sub_account_role");
  }
  return set;
};
